/* ellio Product Card
   Variant switching for the ellio-product-grid section. Keeps the hidden
   `id` input of the add-to-cart form, the displayed price, the variant hint
   and the submit button state in sync with the selected variant radio.
   Works with multiple instances and survives Theme-Editor section reloads. */
(function () {
  if (window.__ellioProductCardLoaded) return;
  window.__ellioProductCardLoaded = true;

  function initCard(root) {
    if (!root || root.dataset.ellioCardInit === 'true') return;
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-variant-option]'));
    if (radios.length < 2) return;
    root.dataset.ellioCardInit = 'true';

    var input = root.querySelector('[data-variant-input]');
    // Absent when the block shows a manual price, which must not be overwritten.
    var priceEl = root.querySelector('[data-variant-price]');
    var noteEl = root.querySelector('[data-variant-note]');
    var hintEl = root.querySelector('[data-variant-hint]');
    // Present only in product mode, where the card links to the chosen product.
    var linkTargets = Array.prototype.slice.call(root.querySelectorAll('[data-card-link-target]'));
    var errorEl = root.querySelector('.product-form__error-message-wrapper');
    var button = root.querySelector('[data-variant-submit]');
    var label = button ? button.querySelector('[data-variant-label]') : null;
    var labelText = label ? label.querySelector('[data-variant-label-text]') : null;
    var soldOutText = button ? button.getAttribute('data-sold-out-label') : '';
    var addText = label ? label.getAttribute('data-add-label') : '';

    function setText(el, value) {
      if (!el) return;
      el.textContent = value;
      el.hidden = value === '';
    }

    function apply(radio) {
      var available = radio.getAttribute('data-available') === 'true';

      if (input) input.value = radio.value;
      if (priceEl && radio.getAttribute('data-price')) {
        priceEl.textContent = radio.getAttribute('data-price');
      }
      setText(noteEl, radio.getAttribute('data-note') || '');
      setText(hintEl, radio.getAttribute('data-hint') || '');

      var cardLink = radio.getAttribute('data-card-link');
      if (cardLink) {
        linkTargets.forEach(function (a) {
          a.setAttribute('href', cardLink);
        });
      }

      // A pending error belongs to the variant that produced it.
      if (errorEl) errorEl.setAttribute('hidden', '');

      if (!button) return;
      button.disabled = !available;
      if (labelText) labelText.textContent = available ? addText : soldOutText;

      // While a cart request is in flight, aria-disabled and .loading are
      // product-form.js's double-submit guard and its own to clear.
      if (button.classList.contains('loading')) return;
      button.removeAttribute('aria-disabled');
      var spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
      var soldOut = button.querySelector('.sold-out-message');
      if (soldOut) soldOut.classList.add('hidden');
      if (label) label.classList.remove('hidden');
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio);
      });
    });

    // Browsers restore radio state on reload and back-navigation, which can
    // disagree with the variant the server rendered the price and id for.
    var checked = root.querySelector('[data-variant-option]:checked');
    if (checked) apply(checked);
  }

  function initAll(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(host.querySelectorAll('[data-ellio-card]')).forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
